import { render, staticRenderFns } from "./TypeALaCarte.vue?vue&type=template&id=5eac4eca&scoped=true"
import script from "./TypeALaCarte.vue?vue&type=script&lang=js"
export * from "./TypeALaCarte.vue?vue&type=script&lang=js"
import style0 from "./TypeALaCarte.vue?vue&type=style&index=0&id=5eac4eca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eac4eca",
  null
  
)

export default component.exports